/**
 * ArubaSubNav — sibling of MerakiSubNav, scoped to Aruba pages.
 *
 * Render at the top of every `/aruba/*` page. When the user has not yet
 * configured an Aruba key, only the setup page is exposed so the rest of
 * the Aruba surface stays out of reach until registration succeeds.
 */
import { useAuth } from "@/stores/auth";
import { SubNav } from "@/components/app/sub-nav";

export function ArubaSubNav() {
  const arubaKeyConfigured =
    useAuth((s) => s.user?.arubaKeyConfigured) === true;

  const items = arubaKeyConfigured
    ? [
        { label: "Manage devices", to: "/aruba/devices" },
        { label: "Sites", to: "/aruba/sites" },
        { label: "WLANs", to: "/aruba/wlans" },
        { label: "Group management", to: "/aruba/groups" },
        { label: "RDV queue", to: "/aruba/rdv" },
        { label: "Firmware update", to: "/aruba/firmware" },
        { label: "Onboarding", to: "/aruba/onboarding" },
        { label: "User creation", to: "/aruba/users" },
      ]
    : [{ label: "Set API key", to: "/aruba/keys" }];

  return <SubNav items={items} />;
}
